// @flow
import LogsDashboard from './LogsDashboard.container';

export default LogsDashboard;
